import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
    function initializeHomeHairBlock() {
        var splideElements = document.querySelectorAll('.home-hair__slider.splide');

        if (splideElements.length > 0) {
            splideElements.forEach(function (splideElement) {
                if (splideElement.classList.contains('is-initialized')) {
                    return;
                }

                var proceduresList = splideElement.querySelector('.procedures-list');

                if (!proceduresList) {
                    return;
                }

                proceduresList.classList.add('splide__list');
                proceduresList.querySelectorAll(':scope > li').forEach(function (item) {
                    item.classList.add('splide__slide');
                });

                var options = JSON.parse(splideElement.getAttribute('data-splide'));
                var splide = new Splide(splideElement, options);

                splide.mount();
            });
        }
    }
    
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=home-hair', initializeHomeHairBlock );
        initializeHomeHairBlock();
    } else {
        initializeHomeHairBlock();
    }
});
